<template>
	<div>
		<div class="i-content flex-row" v-if="inputStyle == 'goodsDetail'">
			<input class="i-input" v-model="currentValue" @blur="handleBlur" />
			<div class="flex-col" v-if="isShowStep">
				<span class="i-span" @click="increase"><i class="el-icon-plus"></i></span>
				<span class="i-span" @click="decrease"><i class="el-icon-minus"></i></span>
			</div>
		</div>
		<div :class="{ 'i-horizontal-content': true, 'disabled-input': disabled }" v-else>
			<span class="i-span-horizontal horizontal-left" @click="decrease"><i class="el-icon-minus"></i></span>
			<input :disabled="disabled" class="i-input i-input-horizontal" v-model="currentValue" @blur="handleBlur" />
			<span class="i-span-horizontal horizontal-right" @click="increase"><i class="el-icon-plus"></i></span>
		</div>
	</div>
</template>

<script>
	import { system } from "../../utils/api-utils/api-sys.js";
	import commonUtils from "../../utils/common-utlis.js";
	export default {
		name: "input-number",
		props: {
			max: {
				type: Number,
				default: Infinity,
			},
			min: {
				type: Number,
				default: -Infinity,
			},
			step: {
				type: Number,
				default: 1,
			},
			curval: {
				type: Number,
				default: 0,
			},
			isTimedSaleSpec: {
				type: Boolean,
				default: false,
			},
			inputStyle: {
				type: String,
				default: "goodsDetail", // goodsDetail竖向加减 shopcart横向加减
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			cartId: {
				type: Number,
			},
			unitRate: {
				type: Number,
				default: 1,
			},
			goodsId: {
				type: String,
				default: "",
			},
			specId: {
				type: String,
				default: "",
			},
			isMultiSpecUnit: {
				type: Boolean,
				default: false,
			},
			isShowStep: {
				type: Boolean,
				default: true,
			},
			decimalDigits: {
				type: Number,
				default: 0,
			},
		},
		watch: {
			//监听父组件传值
			curval: {
				handler(newValue, oldValue) {
					this.currentValue = newValue;

					// v-modal绑定的currentValue 更新前的值
					this.beforeChangeValue = newValue;
				},
				// 强制立即执行回调
				immediate: true,
			},
			step(newValue, oldValue) {
				this.step = newValue;
			},
		},
		data() {
			return {
				currentValue: this.curval,
			};
		},
		methods: {
			increase() {
				if (this.disabled) {
					return;
				}

				let newVal = this.currentValue === 0 ? this.min : this.currentValue + this.step;
				this.setCurrentValue(newVal, true);
			},
			decrease() {
				if (this.disabled) {
					return;
				}

				let newVal = this.currentValue - this.step;
				this.setCurrentValue(newVal);
			},
			handleBlur(e) {
				let value = e.target.value;
				// 支持小数位数输入
				let newVal;
				if (this.decimalDigits > 0) {
					// 支持小数输入，根据decimalDigits处理
					newVal = parseFloat(value);
					if (isNaN(newVal) || !isFinite(newVal)) {
						newVal = this.min;
					} else {
						newVal = parseFloat(newVal.toFixed(this.decimalDigits));
					}
				} else {
					// 不支持小数输入，检查是否包含小数点
					if (value.includes(".")) {
						this.$message.error("该商品不支持小数数量输入");
						this.currentValue = this.beforeChangeValue;
						return;
					}
					newVal = parseInt(value.replace(/[^\d]/g, ""));
					if (!newVal) {
						newVal = this.min;
					}
				}

				// 判断当前值是否满足 最小起购量 和 单次购买倍数（不支持小数时才验证）
				if (this.decimalDigits <= 0 && newVal > 0 && (newVal - this.min) % this.step > 0) {
					// this.$message.error("购买数量必须为单次购买量" + this.step + "的倍数加最小起购量" + this.min)
					newVal = this.min + this.step * parseInt((newVal - this.min) / this.step);
				}

				this.setCurrentValue(newVal);
			},
			setCurrentValue(newVal, isPlus) {
				// 支持小数位数输入
				if (this.decimalDigits > 0) {
					newVal = parseFloat(newVal);
					if (isNaN(newVal)) {
						newVal = this.currentValue;
					} else {
						newVal = parseFloat(newVal.toFixed(this.decimalDigits));
					}
				} else {
					newVal = parseInt(newVal);
				}

				// 判断商品级限购量 并重新赋值max
				let tempMax = this.getGoodsLimitDataListMax();

				// 可购量 不满足 最小起购量
				if (tempMax < this.min) {
					this.currentValue = this.isTimedSaleSpec ? 0 : tempMax;

					let msg = isPlus || newVal > tempMax ? `不能再多了` : "不能再少了";
					this.$message.error(msg);

					this.$emit("change", this.currentValue, this.cartId);
					return;
				}

				let errmsg = "";

				if (newVal < this.min) {
					errmsg = (this.currentValue != 0 && "不能再少了") || "";
					newVal = this.min;
				}
				if (newVal > tempMax) {
					errmsg = "不能再多了";
					newVal = tempMax;
				}

				// 判断当前值是否满足 最小起购量 和 单次购买倍数（不支持小数时才验证）
				if (this.decimalDigits <= 0 && newVal > 0 && (newVal - this.min) % this.step > 0) {
					// errmsg = "购买数量必须为单次购买量" + this.step + "的倍数加最小起购量" + this.min;
					newVal = this.min + this.step * parseInt((newVal - this.min) / this.step);
				}
				// 提示错误信息
				errmsg && this.$message.error(errmsg);

				this.currentValue = newVal;
				this.$emit("change", newVal, this.cartId);
				this.refreshGoodsLimitDataList(newVal);
			},

			/**
			 * 根据商品级限购量 计算max
			 */
			getGoodsLimitDataListMax() {
				let goodsLimitDataList = system.getGoodsLimitDataList() || [];
				let matchGoodsLimitData = goodsLimitDataList.find(item => item.goodsId == this.goodsId) || {};
				if (
					!this.goodsId ||
					!(goodsLimitDataList && goodsLimitDataList.length > 0) ||
					commonUtils.isEmptyObjectV2(matchGoodsLimitData)
				) {
					return this.max;
				}

				// 当前货品所有当前规格单位的加购量
				let curUnitAllCount = commonUtils.sumArr(matchGoodsLimitData.addCountOfSpecUnitList, "addCount");

				// 当前货品非当前规格单位的加购量
				let curUnitNeedMinusCount = commonUtils.sumArr(
					(matchGoodsLimitData.addCountOfSpecUnitList || []).filter(
						item => item.specUnit != `${this.specId}${this.unitRate}`
					),
					"addCount"
				);
				// 当前单位换算后的 商品级限购量（支持小数）
				let curUnitMax = (matchGoodsLimitData.customerLimitCount - curUnitNeedMinusCount) / this.unitRate;
				// 重新计算max
				return matchGoodsLimitData.customerLimitCount <= curUnitAllCount
					? this.beforeChangeValue
					: Math.min(curUnitMax, this.max);
			},

			/**
			 * 更新goodsLimitDataList
			 */
			refreshGoodsLimitDataList(newVal) {
				let goodsLimitDataList = system.getGoodsLimitDataList() || [];
				let matchGoodsLimitData = goodsLimitDataList.find(item => item.goodsId == this.goodsId) || {};

				if (
					!this.goodsId ||
					!(goodsLimitDataList && goodsLimitDataList.length > 0) ||
					commonUtils.isEmptyObjectV2(matchGoodsLimitData) ||
					!this.isMultiSpecUnit
				) {
					return;
				}

				let temp = matchGoodsLimitData.addCountOfSpecUnitList.find(
					item => item.specUnit == `${this.specId}${this.unitRate}`
				);

				if (temp) {
					temp.addCount = newVal * this.unitRate;
				} else {
					matchGoodsLimitData.addCountOfSpecUnitList.push({
						specUnit: `${this.specId}${this.unitRate}`,
						addCount: newVal * this.unitRate,
					});
				}
				console.log(system.getGoodsLimitDataList());
			},
		},
	};
</script>

<style scoped="scoped">
	.i-content {
		align-items: center;
		width: 87px;
		height: 30px;
		border: 1px solid #dcdfe6;
		border-radius: 6px;
		margin: 9px 0;
	}

	/* 	.i-span {
		margin-left: 9px;
		font-size: 8px;
		border: 1px solid #DCDFE6;
	} */

	.i-span {
		font-size: 12px;
		border: 1px solid #dcdfe6;
		padding: 2px;
		cursor: pointer;
		margin: 1px 0 1px 9px;
		line-height: 12px;
		text-align: center;
		height: 12px;
		width: 12px;
		border-radius: 2px;
	}

	.i-input {
		height: 26px;
		width: 81px;
		border: none;
		text-align: center;
		font-size: 15px;
	}

	.i-input:focus {
		outline: none;
	}

	.i-horizontal-content {
		display: flex;
		justify-content: space-around;
		cursor: pointer;
	}

	.i-input-horizontal {
		height: 33px;
		border: 1px solid #dcdfe6;
		border-radius: unset;
		width: 80%;
	}

	.i-span-horizontal {
		border: 1px solid #dcdfe6;
		font-size: 13px;
		padding: 10px;
		/* cursor: pointer; */
		border-radius: 4px;
		width: 10%;
	}

	.horizontal-right {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		margin-left: -1px;
	}

	.horizontal-left {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		margin-right: -1px;
	}

	.disabled-input {
		background-color: #f5f7fa;
		cursor: not-allowed;
	}
</style>
